import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";
import Slideshow from "../../assets/Slideshow/Slideshow";
import tweekrachtimg1 from "../../assets/Images/tweekracht/1.jpeg"
import tweekrachtimg2 from "../../assets/Images/tweekracht/2.jpeg"
import tweekrachtimg3 from "../../assets/Images/tweekracht/3.jpeg"
import tweekrachtimg4 from "../../assets/Images/tweekracht/4.jpeg"
import tweekrachtimg5 from "../../assets/Images/tweekracht/5.jpeg"
import tweekrachtimg6 from "../../assets/Images/tweekracht/6.jpeg"
import tweekrachtimg7 from "../../assets/Images/tweekracht/7.jpeg"
import tweekrachtimg8 from "../../assets/Images/tweekracht/8.jpeg"


import tweekrachtvid1 from "../../assets/Videos/1.mp4"

import "./SchoolProjects.css";

const TweekrachtApp = () => {
  // Replace with your real images later
  const images = [tweekrachtimg1,tweekrachtimg2,tweekrachtimg3,tweekrachtimg4,tweekrachtimg5,tweekrachtimg6,tweekrachtimg7,tweekrachtimg8,tweekrachtvid1];

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="page-container">
      <Navbar />

      <div className="content-lo1-headings">
        <h1>Tweekracht App</h1>
        <p>A client project turning social work case notes into structured board game cards—built to be simple for
  social workers to generate, review, and edit.</p>
      </div>

      <div className="line"></div>

      <div className="breadcrumb-wrap" style={{ padding: "0.1rem 7.5rem" }}>
        <BreadcrumbHeader />
      </div>


      <div className="content-lo1">
        <div className="tweekracht-layout">
          {/* LEFT: Case Study Content */}
          <div className="tweekracht-left">
            {/* Quick nav / anchors */}
            <div className="tweekracht-anchors">
              <button onClick={() => scrollToId("overview")}>Overview</button>
              <button onClick={() => scrollToId("snapshot")}>Snapshot</button>
              <button onClick={() => scrollToId("process")}>Process</button>
              <button onClick={() => scrollToId("outcome")}>Outcome</button>
              <button onClick={() => scrollToId("reflection")}>Reflection</button>
            </div>

            <section id="overview" className="tweekracht-section">
              <h2>Project Overview</h2>
              <p>
                The Tweekracht App is an industry project developed in collaboration with a client in
                the field of social work. The client created an educational board game that translates
                real-life social work cases into a structured set of cards, guiding players through
                decision-making based on an established theoretical framework.
              </p>
              <p>
                Creating new cases for the game was a manual and time-consuming process. To address
                this challenge, the project focused on designing an AI Case Generator app that helps
                translate written case documentation into structured game cards. The generated content
                can then be reviewed and edited by social workers before being used in the board game.
              </p>
              <p>
                My main responsibility was to design a simple and intuitive user interface that supports
                non-technical users while respecting the existing game structure and theoretical foundations.
              </p>
            </section>

            <section id="snapshot" className="tweekracht-section">
              <h2>Project Snapshot</h2>

              <div className="tweekracht-snapshot">
                <div className="snapshot-item">
                  <span className="snapshot-label">Role</span>
                  <span className="snapshot-value">UX/UI, prototyping, integration support</span>
                </div>
                <div className="snapshot-item">
                  <span className="snapshot-label">Tools</span>
                  <span className="snapshot-value">Figma, Flutter, Firebase, Git</span>
                </div>
                <div className="snapshot-item">
                  <span className="snapshot-label">Goal</span>
                  <span className="snapshot-value">Turn case docs structured into game cards</span>
                </div>
                <div className="snapshot-item">
                  <span className="snapshot-label">Users</span>
                  <span className="snapshot-value">Social workers (non-technical)</span>
                </div>
              </div>
            </section>

            <section className="tweekracht-section">
              <h2>Key Features</h2>
              <ul>
                <li>Simple case-to-card flow (generate, review, edit)</li>
                <li>Clear structure for rounds and consequences (game logic supported in UI)</li>
                <li>Card editor to review and refine AI output</li>
                <li>Data stored in Firebase for reuse and collaboration</li>
                <li>Export-ready structure (JSON) to support the board game team</li>
              </ul>
            </section>

            <section id="process" className="tweekracht-section">
              <h2>Process</h2>

              <h3>Sprint 1 — Understanding & Low-Fidelity Design</h3>
              <ul>
                <li>Captured requirements and clarified scope with the client</li>
                <li>Sketched early layouts and user flows</li>
                <li>Created a low-fidelity prototype to support discussion</li>
                <li>Mapped key game logic (joker usage, consequences) with a flowchart</li>
              </ul>

              <h3>Sprint 2 — Validation & Technical Exploration</h3>
              <ul>
                <li>Prepared UX interview questions and conducted an interview with a social worker</li>
                <li>Used prototypes to get concrete feedback and iterate</li>
                <li>Built a small Swift prototype to test design feasibility</li>
                <li>Researched export methods to share data with the board game team</li>
                <li>Switched to Flutter for cross-platform delivery (iOS + Android)</li>
                <li>Connected to Firebase Firestore and exported JSON to an online database</li>
              </ul>
            </section>

            <section id="outcome" className="tweekracht-section">
              <h2>Outcome</h2>
              <ul>
                <li>Client confirmed the prototype direction and usability approach</li>
                <li>Interview insights helped refine layout and editing flow for non-technical users</li>
                <li>Cross-platform approach enabled wider accessibility (Flutter)</li>
                <li>Firebase integration supported saving and exporting structured cases</li>
              </ul>
            </section>

            <section id="reflection" className="tweekracht-section">
              <h2>What Did I Learn?</h2>
              <p>
                This project taught me how important clarity and structure are when designing tools for
                non-technical users. Working with a real client pushed me to communicate design decisions
                clearly and iterate quickly based on feedback.
              </p>
              <p>
                I also learned to adapt when technical requirements changed—moving from Swift experiments
                to Flutter for cross-platform development—and to think about how data should be stored and
                shared so other teams can use it (Firebase + export formats).
              </p>
            </section>
          </div>

          {/* RIGHT: Sticky Slideshow */}
          <aside className="tweekracht-right">
            {images.length > 0 ? (
              <Slideshow images={images} />
            ) : (
              <div className="slideshow-placeholder">
                <p>Slideshow Placeholder</p>
                <p>Add images to the images array to display slideshow</p>
              </div>
            )}

            <div className="tweekracht-caption">
              <p>
                
              </p>
            </div>
          </aside>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TweekrachtApp;
